<template>
  <div class="pt-2 mt-2">
    <v-layout row>
      <v-flex xs12>
        <v-card>
<!-- The quadrant toolbar -->
          <OperationalScreen_QuadrantToolbar
            :componentId="properties.componentId"
            :headers="headers"
            :title="properties.tag"
            :toolBarOptions="false"
          >
          </OperationalScreen_QuadrantToolbar>
          <v-dialog v-model="enableCreateIncident" max-width="740" persistent>
            <v-form ref="aspectForm" v-model="valid" lazy-validation>
<!-- The toolbar of the dialog -->
              <v-toolbar
                v-if="!editSelectedIncident"
                class="toolbar"
                color="primary"
                dark
                height="50rem"
              >
                <v-toolbar-title
                  color="white"
                  class="mr-2 headline"
                  v-if="incidentSelect"
                >{{$translate('INCIDENT_TYPE' )}}</v-toolbar-title>
                <v-toolbar-title
                  color="white"
                  class="mr-2 headline"
                  v-if="incidentInput"
                >{{$translate('INCIDENT_FILL_IN')}}</v-toolbar-title>
                <v-toolbar-title
                  color="white"
                  class="mr-2 headline"
                  v-if="incidentMap"
                >{{$translate('SELECT_LOCATION')}}</v-toolbar-title>
              </v-toolbar>
              <v-layout row>
<!-- Screen with incident icons -->
                <v-card id="dialogCard" max-width="780" v-if="incidentSelect">
                  <h1 class="center" color="primary">{{$translate('INCIDENT_HAPPEND')}}</h1>
                  <v-flex
                    xs12
                    @click="showIncidentInput(item)"
                    elevation-5
                    round
                    class="image-block"
                    v-for="(item, index) in items"
                    :key="index"
                  >
                    <v-icon class="incidentIcons" x-large>{{item.image}}</v-icon>
                    <p class="image-text">{{item.title}}</p>
                  </v-flex>
                  <v-layout align-end justify-end row fill-heigh>
                    <v-btn
                      round
                      class="text-capitalize"
                      @click="enableCreateIncident = false"
                      color="secondary"
                    >{{$translate('LINDA_CANCEL_ORDER')}}</v-btn>
                  </v-layout>
                </v-card>
              </v-layout>
              <v-layout row>
<!-- Incident input screen -->
                <v-card id="dialogCard" width="740" v-if="incidentInput">
                  <v-layout>
                    <v-flex ma-1 mt-4 xs4 class="iconBlock">
                      <v-layout mt-2 pt-1 column align-center justify-center fill-height>
                        <v-icon x-large>{{aspectForm.incidentType.image}}</v-icon>
                        <p class="image-text">{{aspectForm.incidentType.title}}</p>
                      </v-layout>
                    </v-flex>
                    <v-flex ma-1 xs8>
                      <h4>{{$translate('INCIDENT_PICTURE')}}</h4>
                      <event-image-loader
                        class="imageBorder"
                        clearable
                        v-model="aspectForm.Image"
                        :properties="imageProperties"
                        v-on:load_image="setImageElement"
                      ></event-image-loader>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-layout>
                      <v-flex xs12 d-inline-block>
                        <h3>{{$translate('ADD_A_LOCATION')}}</h3>
                        <v-layout>
                          <v-flex pa-1 xs10>
                            <v-text-field
                              label="Your location"
                              outline
                              required
                              v-model="aspectForm.Location"
                              :rules="locationRules"
                              disabled
                            ></v-text-field>
                          </v-flex>
                          <v-flex centered pa-1 xs2 class="locationSelector" @click="showMap()">
                            <v-layout align-center row justify-end fill-height>
                              <v-icon color="999999" large>places</v-icon>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                  <v-flex xs12 class="dialogCardDiv">
                    <h3>{{$translate('INCIDENT_DESCRIPTION')}}</h3>
                    <v-textarea
                      outline
                      :label="$translate('INCIDENT_DESCRIPTION')"
                      clearable
                      required
                      auto-grow
                      v-model="aspectForm.Description"
                      :rules="descriptionRules"
                    ></v-textarea>
                  </v-flex>
                  <v-layout row>
                    <v-flex xs12 offset-xs5>
                      <v-layout align-end justify-center row fill-height>
                        <v-layout class="bottomDialog" align-end justify-end>
                          <v-btn
                            round
                            class="text-capitalize"
                            @click="closeIncidentInput()"
                            color="secondary"
                          >{{$translate('LINDA_CANCEL_ORDER')}}</v-btn>
                          <v-btn
                            round
                            class="text-capitalize"
                            @click="reportIncident()"
                            color="primary"
                          >{{$translate('INCIDENT_SEND')}}</v-btn>
                        </v-layout>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
                <v-card v-if="this.incidentMap">
                  <v-flex mb-1 pa-3 class="mapTab">
                    <OperationalScreen_MapQuadrant :properties="locationProps" class="screenMap"></OperationalScreen_MapQuadrant>
                  </v-flex>
                  <v-flex xs12 offset-xs5>
                    <v-layout align-end justify-center row fill-height>
                      <v-layout class="bottomDialog" align-center justify-end>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon medium v-on="on">info</v-icon>
                          </template>
                          <span>{{$translate('MAP_SELECT_LOCATION')}}</span>
                        </v-tooltip>
                        <v-btn
                          round
                          class="text-capitalize"
                          @click="closeIncidentMap()"
                          color="secondary"
                        >{{$translate('LINDA_CANCEL_ORDER')}}</v-btn>
                        <v-btn
                          round
                          class="text-capitalize"
                          @click="closeIncidentMap()"
                          color="primary"
                        >{{$translate('CONTINUE')}}</v-btn>
                      </v-layout>
                    </v-layout>
                  </v-flex>
                </v-card>
              </v-layout>
            </v-form>
            <v-form>
<!-- Edit incident screen -->
              <v-card width="740" v-if="editSelectedIncident">
                <v-layout row>
                  <v-flex xs5 ma-3 class="dialogCardDiv">
                      <v-img
                      max-height="400"
                      :src="attachmentOfEditedIncident"
                    ></v-img>
                  </v-flex>
                  <v-flex ma-2 xs6 height="200" class="mapTab">
                    <OperationalScreen_MapQuadrant
                      :properties="locationProps"
                      class="screenMap"
                      max-height="100"
                      disabled
                    ></OperationalScreen_MapQuadrant>
                  </v-flex>
                </v-layout>
                <p>{{$translate('TYPE')}}:</p>
                <p>{{editAspect.DataFieldTable.IncidentType}}</p>
                <v-layout class="bottomDialog" align-end justify-end>
                  <v-btn
                    round
                    class="text-capitalize"
                    color="secondary"
                    @click="closeEditIncident()"
                  >{{$translate('LINDA_CANCEL_ORDER')}}</v-btn>
                  <v-btn round class="text-capitalize" @click="updateIncident(descriptionOfTheEditor, editAspect)" color="primary">{{$translate('SAVE')}}</v-btn>
                </v-layout>
              </v-card>
            </v-form>
          </v-dialog>
<!-- Screen with all the incident -->
          <div>
            <v-layout class="toolBarTwoSize" row wrap>
              <v-flex class="graph_out_base box-size xs3">
                <p class="graph_title">{{$translate('TOTAL_INCIDENTS')}}</p>
                <div class="inc_container text-xs-center">
                  <p class="write">{{totalIncidents}}</p>
                </div>
              </v-flex>
              <v-flex class="graph_out_base box-size xs3">
                <p class="graph_title"></p>
                <div class="inc_container text-xs-center">
                  <p class="write"></p>
                </div>
              </v-flex>
              <v-flex class="graph_out_base box-size xs3">
                <p class="graph_title"></p>
                <div class="inc_container text-xs-center">
                  <p class="write"></p>
                </div>
              </v-flex>
              <v-flex class="graph_out_border box-size xs3">
                <v-tooltip top>
                  <v-btn
                    fab
                    slot="activator"
                    :disabled="this.$store.getters['auth/userLevel'] < 5"
                    small
                    class="test"
                    color="primary"
                    @click="showAddIncident()"
                  ><v-icon>add</v-icon></v-btn>
                  <span>{{$translate('ADD_INCIDENT')}}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <v-layout v-if="incidents.length == 0" class="text-xs-center">
              <v-flex class="incidentBackground">
                <v-chip>{{$translate('NO_INCIDENT')}}</v-chip>
              </v-flex>
            </v-layout>
<!-- List of all the incidents -->
            <div class="incidentBackground" v-else>
              <v-list two-line class="incidentDialog">
                <template v-for="(item, index) of incidents">
                  <v-list-tile :style="`background-color: ${setBackgroundColor(item)}`" :key="index">
                    <v-avatar size="35" class="mr-4">
                      <img :aspect-ratio="14/9" :src="require('../../assets/INCIDENT/incident_old.png')" />
                    </v-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title class="listTitle">{{item.DataFieldTable.IncidentType}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{item.DataFieldTable.Description}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-layout row>
                        <v-tooltip bottom>
                          <v-btn
                            small
                            round
                            slot="activator"
                            color="primary"
                            icon
                            @click="getAspectWithData(item)"
                          >
                            <v-icon small>edit</v-icon>
                          </v-btn>
                          <span>{{$translate('VIEW_DETAILS')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="item.state !== 'close'">
                          <v-btn
                            small
                            round
                            class="ml-3"
                            slot="activator"
                            color="secondary"
                            icon
                            @click="getDialogForClosing(item)"
                          >
                            <v-icon  medium>close</v-icon>
                          </v-btn>
                          <span>{{$translate('CLOSE')}}</span>
                        </v-tooltip>
<!-- Close incident dialog -->
                        <div class="text-xs-center">
                          <v-dialog
                            width="500"
                            persistent
                            v-model="closeDialog"
                          >
                            <v-card>
                              <v-card-title
                                class="headline grey lighten-2"
                                primary-title
                              >
                                {{$translate('INCIDENT_CLOSE')}}
                              </v-card-title>
                              <v-card-text>
                                {{$translate('INCIDENT_DIALOG_CLOSE')}}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  flat
                                  @click="closeDialog = false"
                                >
                                  {{$translate('NO_IM_NOT')}}
                                </v-btn>
                                <v-btn
                                  color="primary"
                                  flat
                                  @click="updateIncident('', SelectedIncident, 'close')"
                                >
                                  {{$translate('YES_I_AM')}}
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </div>
                      </v-layout>
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-divider v-if="index + 1 < incidents.length" :key="`divider-${index}`"></v-divider>
                </template>
              </v-list>
            </div>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../../config/app_config";
import OperationalScreen_MapQuadrant from "./OperationalScreen_MapQuadrant";
import OperationalScreen_BaseQuadrant from "./OperationalScreen_BaseQuadrant";
import OperationalScreen_QuadrantToolbar from "./OperationalScreen_QuadrantToolbar";
import IncidentManagerElement from "../IncidentManagerElement";
import IncidentAspect from "../../aspects/IncidentAspect.js";
import UserAspect from "@/aspects/UserAspect.js";
import EventImageLoader from "@/components/media/EventImageLoader";
import BaseObject from "../../objects/BaseObject";
import LocationAspect from "@/aspects/LocationAspect";
import * as player from "../../shared/player";
import { map_functions } from "../../shared/map_functions.js";
import { optionDateTime } from "../../shared/utility";
import responseFromDss from "../../api/DssResponse";
export default {
  valid     : true,
  name      : "OperationalScreen_IncidentQuadrant",
  props     : {},
  extends   : OperationalScreen_BaseQuadrant,
  mixins    : [map_functions],
  components: {
    EventImageLoader,
    OperationalScreen_QuadrantToolbar,
    OperationalScreen_MapQuadrant,
    IncidentManagerElement
  },
  created() {
    this.headers = ["INCIDENT_TITLE", "INCIDENT_TITLE_2"];
    window.EventBus.listen("showAddIncident", this.showAddIncident);
    window.EventBus.listen("closeAddIncident", this.closeAddIncident);
    window.EventBus.listen(
      "storeSettings" + this.properties.componentId,
      this.saveSettings
    );
    window.EventBus.listen("clickedLocation", this.setLocationPoint);
  },
  beforeDestroy() {
    window.EventBus.removeListener(
      "storeSettings" + this.properties.componentId,
      this.saveSettings
    );
    window.EventBus.removeListener("showAddIncident", this.showAddIncident);
    window.EventBus.removeListener("closeAddIncident", this.closeAddIncident);
    window.EventBus.removeListener("clickedLocation", this.setLocationPoint);
  },
    computed: {
      totalIncidents() {
        // let x = this.incidents
        // for (let [index, item] of Object.entries(x)) {
        //   if(item.dataFieldTable.incidentIcon !== '')
        //     this.incidents.push(item)
        // }
        return this.incidents.length;
      }
    },
    data() {
      return {
        //Rules
        locationRules   : [v => !!v || "Location is required"],
        descriptionRules: [
          v => !!v || "Description is required",
          v =>
            (v && v.length >= 5) ||
            "Descriptiono must be have more than 4 characters"
        ],

        //The incident types
        items                     : [
          { id: 1, title: "Overlast", image: "report_problem" },
          { id: 2, title: "Verkeer", image: "traffic" },
          { id: 3, title: "Afval", image: "delete" },
          { id: 4, title: "Vaargedrag", image: "directions_boat" },
          { id: 5, title: "Kind Vermist", image: "child_friendly" },
          { id: 6, title: "Vernieling", image: "report_problem" }
        ],

        //Properties
        imageProperties: {
          title     : "Background",
          signalName: "load_image",
          deletable : false,
          pictureUrl: "",
          maxWidth  : appConfig.maxSize.home.w,
          maxHeight : appConfig.maxSize.home.h,
          scale     : "w"
        },
        defaultImageProperties: {
          title     : "Background",
          signalName: "load_image",
          deletable : false,
          pictureUrl: "",
          maxWidth  : appConfig.maxSize.home.w,
          maxHeight : appConfig.maxSize.home.h,
          scale     : "w"
        },
        locationProps: {
          component  : "OperationalScreen_MapQuadrant",
          componentId: "OperationalScreen_MapQuadrant_MAPOFINCIDENT",
          fullSize   : true,
          hidden     : false,
          location   : {},
          mainMap    : false,
          name       : "OperationalScreen_MapQuadrant_NPSTNJ",
          params     : {
            partOf: {}
          },
          pinned  : true,
          position: {
            x: 0,
            y: 0
          },
          profile: {
            connect: false,
            default: false,
            landing: true,
            relink : true,
            style  : {
              height: "big"
            }
          },
          showBackButton : true,
          showToolbar    : false,
          signalObjectMap: [],
          tag            : "",
          interaction    : true,
          rightClick     : true,
        },
        AspectForLocation: {
          data: {
            Name: '',
            Data: {

            }
          }
        },
        //To show the dialogs
        enableCreateIncident      : false,
        editSelectedIncident      : false,
        incidentInput             : false,
        incidentSelect            : false,
        incidentMap               : false,
        closeDialog               : false,

        //Data for the incidents
        SelectedIncident          : {},
        descriptionOfTheEditor    : '',
        attachmentOfEditedIncident: {},
        editAspect                : {},
        aspectForm                : {},
        boxConfig                 : {},
        incidents                 : [],
      };
    },
    mounted() {
      this.getDialogIncidentsForLocation(this.$store.getters.getChosenLocationId)

      this.setLocation(this.$store.getters.getChosenLocationId),
        (this.boxConfig = {
          customData: {
            gps: {
              degrees: "",
              decimal: [52, 0]
            }
          },
          parentId: 0,
          component: "IncidentManagerElement",
          name: "Add Incident",
          id: "IncidentManagerElement"
        });
    },
  methods: {
    setBackgroundColor(item){
      if(item.state == 'ON'){
        return 'white';
      }
      else {
        return 'lightgrey';
      }
    },
    getDialogForClosing(data){
      this.closeDialog = true
      this.SelectedIncident = data
    },
    getIconLocation(item) {
      return require("../../assets/INCIDENT/" +
        item.dataFieldTable.state +
        ".svg");
    },
    saveSettings() {
      window.EventBus.fire("storeSettings", {});
    },
    goToCloserEmployee(item) {
      let boxConfig = {
        customData: item,
        parentId  : 0,
        resizable : false,
        component : "UsersList",
        name      : "UsersList",
        id        : "UsersList"
      };
      window.EventBus.fire("openBoxMgr", boxConfig);
    },
    goToCloserCamera(item) {
      let boxConfig = {
        resizable : false,
        customData: item,
        parentId  : 0,
        component : "CameraView",
        name      : "Camera",
        id        : "CameraView"
      };
      window.EventBus.fire("openBoxMgr", boxConfig);
    },
    showAddIncident() {
      this.enableCreateIncident = true;
      this.incidentSelect       = true;
      this.incidentMap          = false;
      this.incidentInput        = false;
      this.editSelectedIncident = false;
    },
    closeAddIncident() {
      this.editSelectedIncident = false;
      this.enableCreateIncident = false;
      this.boxConfig            = {
        customData: {
          gps: {
            degrees: "",
            decimal: [52, 0]
          }
        },
        parentId : 0,
        component: "IncidentManagerElement",
        name     : "Add Incident",
        id       : "IncidentManagerElement"
      };
    },
    showMap() {
      this.editSelectedIncident = false;
      this.incidentInput        = false;
      this.incidentMap          = true;
    },

    closeIncidentMap() {
      this.editSelectedIncident = false;
      this.incidentInput        = true;
      this.incidentMap          = false;
    },
    showIncidentInput(item) {
      this.editSelectedIncident    = false;
      this.incidentSelect          = false;
      this.incidentInput           = true;
      this.aspectForm.incidentType = item;
    },
    closeIncidentInput() {
      this.editSelectedIncident = false;
      this.incidentSelect       = true;
      this.incidentInput        = false;
      this.$refs.aspectForm.reset();
      this.$refs.aspectForm.resetValidation();
      this.imageProperties = this.defaultImageProperties;
    },
    getDialogIncidentsForLocation(location) {

      let payload = {
        AspectType: "Incident"
      };

      dssRequest.doRequest(
        response => {
          console.log(
            "The call getAspects on incidentsScreen was successful",
            response
          );
          if (response.data.hasOwnProperty('incidentAspectUpdate')) {
            this.incidents = Object.values(response.data.incidentAspectUpdate);
          }

        },
        error => {
          console.log(
            "The call getAspects was not successful",
            error
          );
        },
        "getAspects",
        location,
        payload
      );
    },
    // onEvent(container) {
    //   console.log("Brian to check out container", container);
    //
    //   const data = container.data;
    //   if (!_.isEmpty(data.Data) && data.Name == "incidentAspectUpdate") {
    //     this.incidents = [];
    //     for (const [k, v] of Object.entries(data.Data)) {
    //       const obj = this.createAspectBasedOnTypeNew(v);
    //       this.addObject(obj);
    //     }
    //   }
    // },
    insertIncident(gps) {
      //Removed this call as we do not need floating box to add incidents
      window.EventBus.fire("fillIncidentLocation", gps);
    },
    closeEditIncident() {
      this.incidentSelect       = true;
      this.enableCreateIncident = false;
      this.editSelectedIncident = false;
    },
    createAspectBasedOnTypeNew(aspect, callback = null) {
      let addToMap      = true,
          toBeRemoved   = false;
      let _obj          = BaseObject._toLowerCaseObjectProperties(aspect);
          _obj.position = [Number(_obj.longitude), Number(_obj.latitude)];
      let genericAspect = {};
      switch (_obj.type) {
        case "Location":
          let tmp         = _obj.dataFieldTable.polyline.split(" ");
          let newPolyline = "";
          tmp.forEach(i => {
            let h            = i.split(",");
                newPolyline += h.reverse().join() + " ";
          });

          _obj.coordinates = newPolyline;
          delete _obj.dataFieldTable.polyline;
          genericAspect = new LocationAspect(_obj);
          break;

        case "Incident":
          genericAspect = new IncidentAspect(_obj);
          break;

        case "User":
          genericAspect = new UserAspect(_obj);
          break;

        default:
          console.warn("createAspectBasedOnTypeNew NO type recognized", _obj);
          return;
      }

      if (callback !== null)
        callback.addObject({ genericAspect, aspect, addToMap, toBeRemoved });
      return { genericAspect, aspect, addToMap, toBeRemoved };
    },
    // addObject(data) {
    //   if (data.addToMap == false) {
    //     return;
    //   }
    //   if (this.properties.profile.playSound == true) {
    //     player.beep();
    //   }
    //
    //   this.incidents.push(data.genericAspect.getObject());
    // },
    showType(incident) {
      let incidentType = incident.incidentType;
      return incidentType;
    },
    showDate(item) {
      let date = new Date(item.date).toLocaleDateString(
        "nl-NL",
        optionDateTime
      );
      return date;
    },
    showDescription(descr) {
      let description = descr.description;

      if (description == "") {
        description = this.$translate("NO_DESC");
      }
      return description;
    },
    showState(incident) {
      let state = incident.state;
      if (state == "") {
        state = this.$translate("NO_STATE");
      }
      return state;
    },
    moveToIncident(element) {
      window.EventBus.fire("moveToFeature", element);
    },
    openFromList(incident) {
      this.boxConfig = {
        type      : "edit",
        customData: incident,
        parentId  : 0,
        name      : "Incident " + incident.referenceName
      };
      this.enableCreateIncident = true;
    },
    setImageElement(data) {
      if (data.signalName == this.imageProperties.signalName) {
        this.imageProperties.pictureUrl = data.url;
      }
    },

    reportIncident(item) {
      if (!this.$refs.aspectForm.validate()) {
        alert = "You forgot someting";
      } else {
        const payload = {
          AccountId  : this.$store.getters.getCurrentAccountId,
          Description: this.aspectForm.Description,
          Type       : this.aspectForm.incidentType.title,
          Icon       : this.aspectForm.incidentType.image,
          Latitude   : this.aspectForm.Location[1],
          Longitude  : this.aspectForm.Location[0]
        };
        dssRequest.doRequest(
          response => {
            console.log("The generic call for ReportIncident was successful", response);
            this.insertAttachmentAct(response.data.AspectId);
          },
          error => {
            console.log("The generic call for ReportIncident was not successful", error);
          },
          "reportIncident",
          this.$store.getters["auth/userName"],
          payload
        );
        this.enableCreateIncident = false;
        this.incidentSelect       = false;
        this.incidentInput        = false;
        this.$refs.aspectForm.reset();
      }
    },
    insertAttachmentAct(incidentId) {
      const payload = {
        Id        : incidentId,
        Attachment: this.imageProperties.pictureUrl,
        FunctionId: "AspectFunctionLibrary::saveAspectAttachment"
      };
        dssRequest.doRequest(
          response => {
            console.log("The call for insertAttachmentAct was succesfull", response);
          },
          error => {
            console.log("The call for insertAttachmentAct Failed", error);
          },
          "communicateWithDBLibrary",
          this.$store.getters.getCurrentAccountId,
          payload
        );
      this.imageProperties = this.defaultImageProperties;
    },
    getAspectWithData(data) {
      this.descriptionOfTheEditor = '';
      this.incidentSelect       = false;
      this.enableCreateIncident = true;
      this.editSelectedIncident = true;
      this.getAspectAttachment(data);
      const payload = {
        Id        : data.Id,
        FunctionId: "AspectFunctionLibrary::getAspectWithData"
      };
      dssRequest.doRequest(
        response => {
          console.log("The generic call for getAspectWithData was succesfull", response);
          this.editAspect = response.data;
          console.log("Dit is de editAspect", this.editAspect);
          window.EventBus.fire("createAspectBasedOnTypeNew", response.data, this);
        },
        error => {
          console.log("The generic call for getAspectWithData was not successful", error);
        },
        "communicateWithDBLibrary",
        this.$store.getters.getCurrentAccountId,
        payload
      );
    },
    getAspectAttachment(data) {
      const payload = {
        Id        : data.Id,
        FunctionId: "AspectFunctionLibrary::getAspectAttachment"
      };
      dssRequest.doRequest(
        response => {
          console.log("The generic call for getApectAttachment was succesfull", response);
          if (response.data.AspectAttachment.celldata.length > 0) {
            this.attachmentOfEditedIncident = response.data.AspectAttachment.celldata[0][1]
          }
        },
        error => {
          console.log("The generic call for getAspectAttachment was not successful", error);
        },
        "communicateWithDBLibrary",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    setLocation(location) {
      const payload = {
        LocationId     : location,
        StructuredReply: true,
      };
      dssRequest.doRequest(
        response => {
          console.log("The generic call 'getLocationData' on - OperationalScreen_IncidentQuadrant.vue - was successful", response);
          const fullLocationObject = BaseObject._toLowerCaseObjectPropertiesAtFirstLevelWithOutLodash(
            response.data
          );
          let k = Object.keys(fullLocationObject.containers)[0];
          const newK = k[0].toUpperCase() + k.substring(1, k.length);
          this.locationProps.params = {
            partOf: {
              locationId: newK,
              name      : fullLocationObject.containers[k],
              depth     : fullLocationObject.depth - 1       //tricks to re-apply the same depth
            },
            type: "edit"
          };
          fullLocationObject.tags = fullLocationObject.locationTags;
          fullLocationObject.memberOf        = location.memberOf;
          this.locationProps.params.location = fullLocationObject;
        },
        error => {
          console.error("The call for 'getLocationData' on - OperationalScreen_IncidentQuadrant.vue - was not successful", error);
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GLD_001');
        },
        "getLocationData",
        location,
        payload,
        600000,
        false
      );
    },
    clickedLocationOnPlainMap(gps) {
      this.form.polyline = gps.coordinates.map(e => e).join(" ");
    },
    setLocationPoint(clickedLocation) {
      this.aspectForm.Location = clickedLocation.decimal;
    },
    updateAspects(type, toBeUpdatedAspectsList) {
      const ref = this.layerSources[type];
      if (typeof ref === "undefined") {
        // console.error("updateAspects NO LAYER EXIST", type);
        return;
      }
      for (const [k, v] of Object.entries(toBeUpdatedAspectsList)) {
        // debugger;
        if (ref.getFeatureById(k) !== null) {
          const container = this.createAspectBasedOnType2(v);
          ref.getFeatureById(k).setProperties(container.data);
        } else {
          console.warn("NULL ref.getFeatureById(k)", k);
        }
      }
    },
    updateIncident(description, incident,state) {
      if (_.isEmpty(description) && state == undefined) {
        return
      }

      let payload = {}
      if(state == undefined){
        incident.Description = incident.DataFieldTable.Description + ' | ' + description
        incident.State = 'active'
        payload = {
          Id         : incident.Name,
          Name       : incident.Name,
          Description: incident.Description,
          Type       : incident.Type,
          Latitude   : Number(incident.Latitude),
          Longitude  : Number(incident.Longitude),
          Icon       : incident.DataFieldTable.IncidentIcon,
          State      : incident.State
        }
      }
      else if(state == 'close'){
        incident.State = state
        payload = {
          Id         : incident.Name,
          Name       : incident.Name,
          Description: incident.DataFieldTable.Description,
          Type       : incident.DataFieldTable.IncidentType,
          Latitude   : Number(incident.Latitude),
          Longitude  : Number(incident.Longitude),
          Icon       : incident.DataFieldTable.IncidentIcon,
          State      : incident.State
        }
      }
      dssRequest.doRequest(
        response => {
          console.log("The generic call for updateIncident was succesfull", response);
          this.closeDialog          = false;
          this.incidentSelect       = true;
          this.enableCreateIncident = false;
          this.editSelectedIncident = false;
        },
        error => {
          console.log("The generic call for updateIncident was not successful", error);
        },
        "updateIncident",
        this.$store.getters["auth/userName"],
        payload
      );
    }
  }
};
</script>
<style scoped>
.clickable {
  cursor: pointer;
  border-radius: 1em;
  border: 1px solid red;
  margin-right: 1em;
  box-shadow: none;
}
.incidentDialog {
  max-height: calc(50vh - 100px) !important;
  overflow-y: auto;
  overflow-x: hidden;
}
.box-size {
  height: 50px !important;
  width: 25% !important;
}
.graph_out_base {
  background: #eff0ee;
  border-bottom: 1px solid #676868;
  border-left: 1px solid #676868;
}
.graph_out_border {
  background: #eff0ee;
  border-left: 1px solid #676868;
  border-right: 1px solid #676868;
  border-bottom: 1px solid #676868;
}
.graph_title {
  font-size: 12px;
  background-color: #eff0ee;
  text-align: left;
  color: black;
  margin: 0;
}
.icon {
  height: 30px;
}
.write {
  font-size: 20px;
  margin: 0 !important;
  max-height: 30px !important;
}
.toolBarTwoSize {
  margin-left: 0.01em !important;
  max-width: 99.8%;
}
.incidentBackground {
  min-height: calc(32.4vh);
}
.image-block {
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  border-radius: 10px;
  /*border: 1px solid black;*/
  width: 150px;
}
.image-text {
  text-align: center;
}
.center {
  text-align: center;
}
#dialogCard {
  padding: 1em;
}
#dialogCard .image-block {
  margin: 1em;
}
.image-block:hover {
  background-color: #d7d8d6;
}
#dialogCard h3 {
  margin-left: 0.2em;
}
.v-input__slot {
  width: 500px;
}
.bottomDialog {
  margin: 0;
}
.incidentIcons {
  margin-top: 15px;
}
.iconBlock {
  border-radius: 0.3em;
  border: 1.5px solid grey;
  margin-top: 5em;
  height: 8.7em;
}
.imageBorder {
  padding-right: 1em;
  margin-right: 0;
  padding-left: 1em !important;
  margin-bottom: 1.5em;
  margin-top: 0.1em;
  border: 2px solid rgba(0, 0, 0, 0.54);
}
.mapTab {
  width: 52.8em;
}
.screenMap {
  border: 1px solid black;
  padding-top: 0px !important;
}
.locationSelector {
  border: 1.5px solid grey;
  height: 4.2em;
  margin-top: 0.3em;
  border-radius: 0.3em;
  background-color: lightgray;
  cursor: pointer;
}
  .test {
    padding: 1em;
  }
</style>
